import React, { useState, useEffect } from "react";
import { useFilterContext } from "../context/FilterContext";
import Navbar from "./Navbar.js";
import CategoryFilter from "./CategoryFilter.js";
import "./layout.css";
import TicketTable from "./ticket-table/TicketTable.js";
import { useTicketContext } from "../context/TicketContext.js";

const Layout = ({ token }) => {
  const { loading, tickets, getTickets } = useTicketContext();
  const { selectedCategories, updateFilters } = useFilterContext();
  const [refTaskList, setRefTaskList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const CategoryRef = {
    Assignees: "assignedto",
    LOB: "lob",
    Statuses: "displayStatus",
    CheckType: "CheckType",
    TicketType: "workflowtype",
    "Sort by": "Sortby",
  };

  const fetchTickets = async () => {
    await getTickets();
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  useEffect(() => {
    if (tickets) {
      const filteredTasks = filterAndSearchTasks();
      setRefTaskList(filteredTasks);
    }
  }, [tickets, selectedCategories, searchQuery]);

  const filterAndSearchTasks = () => {
    if (!tickets) return [];
    const filtersByCategory = selectedCategories.reduce((acc, filter) => {
      const [category, value] = filter.split(":");
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(value);
      return acc;
    }, {});

    return tickets.filter((task) => {
      task['checkNumber'] = task.metadata && task.metadata.CheckNumber
      task['checkAmount'] = (task.metadata && task.metadata.Amount)
      task['CheckType'] = (task.metadata && task.metadata.CheckType)

      const matchesFilters = Object.entries(filtersByCategory).every(
        ([category, values]) =>
          values.some((value) => task[CategoryRef[category]] === value)
      );

      const matchesSearch =
        searchQuery === "" ||
        Object.values(task).some((value) =>
          String(value).toLowerCase().includes(searchQuery.toLowerCase())
        );

      return matchesFilters && matchesSearch;
    });
  };

  return (
    <div className="layout-container bg-white footer-height">
      <Navbar />

      <div className="flex">
        <div className="w-348 h-screen">
          <CategoryFilter data={tickets} onFilterChange={updateFilters} />
        </div>

        {loading ? (
          <div className="flex w-full justify-center h-screen">
            <p className="loading-custom w-full mt-10 mb-10 py-10 mx-4 bg-background-3 h-50 flex items-center justify-center rounded-md">
              loading...
            </p>
          </div>
        ) : (
          <div className="w-full p-10">
            <div className="flex items-center justify-between mb-6">
              <h1 className="font-28-42-400 poppins-regular">
                Tickets({refTaskList?.length ?? 0})
              </h1>
              <div className="search-container">
                <input
                  type="text"
                  className="search-bar border rounded-md px-4 py-2"
                  placeholder="Search tickets..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const filteredTasks = filterAndSearchTasks();
                      setRefTaskList(filteredTasks);
                    }
                  }}
                />
              </div>
            </div>

            <TicketTable data={refTaskList} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Layout;
